import React from 'react'
import { IconClose } from '@dostavkee/web-ui'
import { Drawer as VaulDrawer } from 'vaul'

import styles from './drawer.module.scss'

export interface DrawerHeaderProps {
    title: string
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ title }) => {
    return (
        <header className={styles['drawer__header']}>
            <VaulDrawer.Handle className={styles['drawer__handle']} />
            <div className={styles['drawer__header-container']}>
                <VaulDrawer.Title className={styles['drawer__title']}>{title}</VaulDrawer.Title>
                <VaulDrawer.Close className={styles['drawer__close-button']}>
                    <IconClose />
                </VaulDrawer.Close>
            </div>
        </header>
    )
}
